/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const verifyRegistrationInputDataSchema = z.object({
	email: z.string().email(),
	code: z.string(),
	password: z.string(),
})

export type VerifyRegistrationInputDataSchema = z.infer<typeof verifyRegistrationInputDataSchema>
